import { useCallback, useEffect, useState } from 'react';
import { Form, Modal, Button, Spinner } from 'react-bootstrap';
import { formatRequestUser } from '../../../util';

export function BindUserModal(props) {
    const { request, show, userId, inProgress, onCancel, onBind, children } = props;
    const [selectedUser, setSelectedUser] = useState(userId || '');

    useEffect(() => {
        setSelectedUser(userId || '');
    }, [show, userId]);
    const handleUserChange = useCallback((e) => {
        setSelectedUser(e.currentTarget.value);
    }, []);
    const handleBindUserClick = useCallback(() => {
        onBind(selectedUser);
    }, [onBind, selectedUser]);

    return (
        <Modal show={show} onHide={onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Укажите соответствующего изображению участника</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>{children}</div>
                <Form.Control as="select" value={selectedUser} onChange={handleUserChange}>
                    <option value="">Никому из перечисленных</option>
                    {request.users
                        .filter((u) => u.role === 'participant')
                        .map((u) => (
                            <option key={u.id} value={u.user.id}>
                                {formatRequestUser(u)}
                            </option>
                        ))}
                </Form.Control>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel}>
                    Отмена
                </Button>
                <Button variant="primary" onClick={handleBindUserClick}>
                    {inProgress && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />}
                    Привязать
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
